import React, { useEffect, useState } from "react"; 
import { useLocation, useParams } from "react-router-dom";
import { FaMapMarkerAlt ,FaShareAlt  } from "react-icons/fa";
// import {
//   FaWifi,
//   FaShuttleVan,
//   FaParking,
//   FaSpa,
//   FaUsers,
//   FaDumbbell,
//   FaSmokingBan ,
//   FaConciergeBell,
//   FaUmbrellaBeach,
//   FaCoffee,
// } from "react-icons/fa";
// import "./PropertyInfo.css";

// import { Star } from "lucide-react";


import PropertyDetailGallery from './Test.jsx';



import PropertyAttribute from './PropertyAttribute.jsx';


import RoomAvaiablity from './RoomAvaiablity.jsx';

import RoomFacilities from './RoomFacilities.jsx';

import RoomRules from './RoomRules.jsx';


import Facilities from './PropertyFacilities';


import RoomReviews from './RoomReviews';


import TravelersAsking from './TravelersAsking';

import { toast } from "react-toastify";




// import "./PropertyGallery.css";

import "./SinglePropertyDetail.css";

const SinglePropertyDetail = () => {
  const { state } = useLocation();
  const { id } = useParams();
 const [property, setProperty] = useState(state?.property || null);
  const [active, setActive] = useState("overview");

const [activeReview, setActiveReview] = useState(0);


  const [reviews, setReviews] = useState([]);
  const [overallAvg, setOverallAvg] = useState(0);
  const [averages, setAverages] = useState({});


const [activeIndex, setActiveIndex] = useState(0);
const [images, setImages] = useState([]);



 const [breakfast, setBreakfast] = useState({
    types: [],
    available: false,
    included: false,
    price: 0,
  });
  const [parking, setParking] = useState(null);
  const [loyalCustomers, setLoyalCustomers] = useState(true);


const CATEGORY_KEYS = [
  { label: "Staff", key: "staff" },
  { label: "Facilities", key: "facilities" },
  { label: "Cleanliness", key: "cleanliness" },
  { label: "Comfort", key: "comfort" },
  { label: "Value for money", key: "valueForMoney" },
  { label: "Location", key: "location" },
];



const tabs = [
    { id: "overview-property-detail", label: "Overview" },
    { id: "booking-section-reserve", label: "Info & prices" },
    { id: "facilities-property-detail", label: "Facilities" },
    { id: "rules-property-detail", label: "House rules" },
    { id: "fine-property-detail", label: "The fine print" },
    { id: "reviews-property-detail", label: "Guest reviews" },
  ];

//   const facilities = [
//   { icon: <FaWifi />, label: "Free Wifi" },
//   { icon: <FaShuttleVan />, label: "Airport shuttle" },
//   { icon: <FaParking />, label: "Free parking" },
//   { icon: <FaSpa />, label: "Spa" },
//   { icon: <FaUsers />, label: "Family rooms" },
//   { icon: <FaDumbbell />, label: "Fitness center" },
//   { icon: <FaSmokingBan  />, label: "Non-smoking rooms" },
//   { icon: <FaConciergeBell />, label: "Room service" },
//   { icon: <FaUmbrellaBeach />, label: "Beachfront" },
//   { icon: <FaCoffee />, label: "Breakfast" },
// ];


//   useEffect(() => {
//     if (!property) {
 

//   const toSlug = (name) => {
//     if (!name) return "unknown";
//     return name
//       .trim()
//       .toLowerCase()
//       .replace(/%20/g, "-")
//       .replace(/\s+/g, "-")
//       .replace(/-+/g, "-");
//   };


//         fetch("https://striking-dedication-production.up.railway.app/api/v1/public/properties", {
//       method: "GET",
//       headers: { "Content-Type": "application/json" },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         // console.log(data)
//         if (data?.data.properties.length) {
//           // ✅ match slug with property name
//           const match = data.data.properties.find(
//             (p) => toSlug(p.propertyName) === id
//           );
//           console.log(match)
//           if (match) setProperty(match);





          
//  fetch(`https://striking-dedication-production.up.railway.app/api/v1/public/reviews`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ vendorId: match.vendorId }),
//     })
//       .then((res) => {
//         if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
//         return res.json();
//       })
//       .then((data1) => {
//         const allReviews = data1?.data?.reviews || [];
//         const approved = allReviews.filter((r) => r.status === "approved");
//         setReviews([...approved,...approved]);

//         const n = approved.length || 0;
//         const avgObj = {};
//         CATEGORY_KEYS.forEach(({ label, key }) => {
//           const sum = approved.reduce(
//             (s, r) => s + (r.ratings?.[key] || 0),
//             0
//           );
//           avgObj[label] = n ? +(sum / n).toFixed(1) : 0;
//         });

//         const overallSum = approved.reduce(
//           (s, r) => s + (r.ratings?.overall || 0),
//           0
//         );
//         const overallAverage = n ? +(overallSum / n).toFixed(1) : 0;
//         console.log(avgObj,overallAverage)
//         setAverages(avgObj);
//         setOverallAvg(overallAverage);
//       })
//       .catch((err) => console.error("Fetch error:", err));



//         }
//       })
//       .catch((err) => console.error("Error fetching properties:", err))
//       // .finally(() => setLoading(false));





//  setBreakfast({
//         types: match?.rooms?.[0]?.breakfast?.types || [],
//         available: match?.rooms?.[0]?.breakfast?.available || false,
//         included: match?.rooms?.[0]?.breakfast?.included || false,
//         price: match?.rooms?.[0]?.breakfast?.price || 0,
//       });

//       setParking(match?.parking || null);

//       // You can make this dynamic later (for now we assume always true)
//       setLoyalCustomers(true);






//     }


    
//   }, [id, property]);


useEffect(() => {
  if (!property) {
    const toSlug = (name) => {
      if (!name) return "unknown";
      return name
        .trim()
        .toLowerCase()
        .replace(/%20/g, "-")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    };

    fetch("https://striking-dedication-production.up.railway.app/api/v1/public/properties", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.properties?.length) {
          const match = data.data.properties.find(
            (p) => toSlug(p.propertyName) === id
          );

          if (match) {
            setProperty(match);
            console.log(match)
            // ✅ Breakfast, parking, loyalty setup — inside this block
            setBreakfast({
              types: match?.rooms?.[0]?.breakfast?.types || [],
              available: match?.rooms?.[0]?.breakfast?.available || false,
              included: match?.rooms?.[0]?.breakfast?.included || false,
              price: match?.rooms?.[0]?.breakfast?.price || 0,
            });

            setParking(match?.parking || null);
            setLoyalCustomers(true);

            // ✅ Fetch reviews using match.vendorId
            fetch(`https://striking-dedication-production.up.railway.app/api/v1/public/reviews`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ vendorId: match.vendorId }),
            })
              .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
              })
              .then((data1) => {
                const allReviews = data1?.data?.reviews || [];
                const approved = allReviews.filter((r) => r.status === "approved");
                console.log(approved)
                setReviews(approved); // duplicated on purpose?

                const n = approved.length || 0;
                const avgObj = {};
                CATEGORY_KEYS.forEach(({ label, key }) => {
                  const sum = approved.reduce(
                    (s, r) => s + (r.ratings?.[key] || 0),
                    0
                  );
                  avgObj[label] = n ? +(sum / n).toFixed(1) : 0;
                });

                const overallSum = approved.reduce(
                  (s, r) => s + (r.ratings?.overall || 0),
                  0
                );
                const overallAverage = n ? +(overallSum / n).toFixed(1) : 0;

                setAverages(avgObj);
                setOverallAvg(overallAverage);
              })
              .catch((err) => console.error("Fetch reviews error:", err));
          }
        }
      })
      .catch((err) => console.error("Error fetching properties:", err));
  }
  else{

    setProperty(property);
            console.log(property)
            // ✅ Breakfast, parking, loyalty setup — inside this block
            setBreakfast({
              types: property?.rooms?.[0]?.breakfast?.types || [],
              available: property?.rooms?.[0]?.breakfast?.available || false,
              included: property?.rooms?.[0]?.breakfast?.included || false,
              price: property?.rooms?.[0]?.breakfast?.price || 0,
            });

            setParking(property?.parking || null);
            setLoyalCustomers(true);

            // ✅ Fetch reviews using property.vendorId
            fetch(`https://striking-dedication-production.up.railway.app/api/v1/public/reviews`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ vendorId: property.vendorId }),
            })
              .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
              })
              .then((data1) => {
                const allReviews = data1?.data?.reviews || [];
                const approved = allReviews.filter((r) => r.status === "approved");
                                console.log(approved)

                setReviews(approved); // duplicated on purpose?

                const n = approved.length || 0;
                const avgObj = {};
                CATEGORY_KEYS.forEach(({ label, key }) => {
                  const sum = approved.reduce(
                    (s, r) => s + (r.ratings?.[key] || 0),
                    0
                  );
                  avgObj[label] = n ? +(sum / n).toFixed(1) : 0;
                });

                const overallSum = approved.reduce(
                  (s, r) => s + (r.ratings?.overall || 0),
                  0
                );
                const overallAverage = n ? +(overallSum / n).toFixed(1) : 0;

                setAverages(avgObj);
                setOverallAvg(overallAverage);

              })

  }
}, [id, property]);





useEffect(() => {
  if (property?.images?.length) {
    setImages(property.images);
  }
}, [property]);

// Auto-slide (optional)
useEffect(() => {
  if (images.length <= 1) return;
  const timer = setInterval(() => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  }, 4000); // change every 4s
  return () => clearInterval(timer);
}, [images]);

const nextImage = () => {
  setActiveIndex((prev) => (prev + 1) % images.length);
};

const prevImage = () => {
  setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
};










  if (!property) return <p></p>;


  return (
    <div className="container">
      <div className="row">
        {/* <div className="col-lg-1"></div> */}
        <div className="col-lg-12">
          <div className="property-header">
            {/* Breadcrumbs */}
            <div className="breadcrumbs">
              <a href="/">Home</a> ›
              <a href="/hotels"> Property</a> ›
              {/* <a href="/pakistan"> Pakistan</a> › */}
              {/* <a href="/sindh"> Sindh</a> › */}
              {/* <a href="/karachi"> Karachi</a> › */}
              <span style={{paddingLeft:"20px"}}>{property?.propertyName || "Property Details"}</span>
            </div>

            {/* Tabs */}
            <div className="property-tabs">
            {tabs.map((tab) => (
                <a
                key={tab.id}
                href={`#${tab.id}`}
                className={active === tab.id ? "active" : ""}
                onClick={() => setActive(tab.id)}
                >
                {tab.label}
                </a>
            ))}
            </div>

            {/* Title Section */}
            <div className="property-info" id="overview-property-detail">
              <div className="title-block">
                <br />
                <h1>{property?.propertyName || "Property Details"}</h1>
                <p className="location">
                      <FaMapMarkerAlt style={{ color: "#3261b8ff", marginRight: "6px" }} />
                  {property?.address || "Karachi, Pakistan"} {property?.city || ""} {property?.zip || ""} –{" "}
                  <a   href={`https://www.google.com/maps?q=${property.lat},${property.long}`} target="_blank">
  View on Google Maps
</a>


                    {/* Good location – */}
                     {/* Show Map</a>*/}
                </p> 
                {/* <span className="stars">{"★".repeat(property?.stars || 4)}</span> */}


       <span className="stars">
  {/* Numeric Average */}
  <strong style={{color:"black"}}>{overallAvg ? overallAvg.toFixed(1) : "0.0"}</strong>
  &nbsp;

  {/* Convert 1–10 rating → 0–5 stars (1 star = 2 points) */}
  {"★".repeat(Math.floor((overallAvg || 0) / 2))}
  {"☆".repeat(5 - Math.floor((overallAvg || 0) / 2))}
            
  <span className="ms-2 status-label" style={{color:"black"}}>
    {(() => {
      const avg = overallAvg || 0;
      if (avg >= 9) return "Outstanding";
      if (avg >= 8) return "Excellent";
      if (avg >= 7) return "Very Good";
      if (avg >= 6) return "Good";
      if (avg >= 5) return "Average";
      if (avg >= 4) return "Below Average";
      if (avg >= 3) return "Fair";
      if (avg >= 2) return "Poor";
      return "Terrible";
    })()}
  </span>
  <br />
  <span className="ms-2 status-label" style={{color:"grey",textDecoration:"underline"}}>
    {reviews.length } reviews
  </span>
</span>



                {/* {property?.beachfront && <span className="tag">Beachfront</span>} */}
              </div>

              {/* Action Buttons */}
              <div className="actions">
                {/* <button className="icon-btn">♡</button> */}
                {/* <button className="icon-btn">⇄</button> */}
                <button
  className="icon-btn"
  onClick={() => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        toast.success("🔗 Page URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy URL:", err);
      });
  }}
>
<FaShareAlt />
</button>

                {/* <button className="reserve-btn">Reserve</button> */}


                <button
  className="reserve-btn"
  onClick={() => {
    const el = document.getElementById("booking-section-reserve");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }}
>
  Reserve
</button>



              </div>
            </div>
          </div>





{/* <PropertyDetailGallery property={property} /> */}







<div className="container property-detail">
      <div className="row">
        {/* LEFT: Images */}
        <div className="col-xl-9 col-lg-9">



          {/* <div className="main-photo">
            <img src={property.mainImage} alt={property.propertyName} />
          </div>
          <div className="photo-grid">
            {property.images?.slice(0, 5).map((img, i) => (
              <div key={i} className="photo-thumb">
                <img src={img} alt={`Gallery ${i}`} />
                {i === 4 && property.images.length > 5 && (
                  <span className="more-photos">
                    +{property.images.length - 5} photos
                  </span>
                )}
              </div>
            ))}
          </div> */}

          <PropertyDetailGallery property={property} />



        </div>

        {/* RIGHT: Reviews + Location */}
        <div className="col-xl-3 col-lg-3" style={{marginTop: "13px"}}>
          {/* <div className="review-box">
            <h5>{property.reviews?.text || "Guest rating"}</h5>
            <div className="review-score">
              <span className="score">{property.reviews?.score || "0.0"}</span>
              <span className="total">
                {property.reviews?.total || 0} reviews
              </span>
            </div>
          </div> */}

{/* 
<div className="review-box">
    <h5>Guest Rating</h5>

<div className="reviews-container-property-details">
  {reviews.length > 0 ? (
    reviews.map((r, i) => (
      <div key={i} className="review-card-property-details">
        <div className="review-avatar-property-details">
          <span>{r.user?.fullName?.charAt(0).toUpperCase() || "U"}</span>
        </div>

        <div className="review-content-property-details">
          <h5 className="reviewer-name-property-details">{r.user?.fullName || "Unknown User"}</h5>

          <div className="review-rating-property-details">
            <span className="rating-score-property-details">{r.ratings?.overall?.toFixed(1) || 0}</span>
            <span className="stars-property-details">
              {"★".repeat(Math.round((r.ratings?.overall || 0) / 2))}
              {"☆".repeat(5 - Math.round((r.ratings?.overall || 0) / 2))}
            </span>
            <br />
                <span className="status">
      {overallAvg >= 9
        ? "Exceptional"
        : overallAvg >= 8
        ? "Wonderful"
        : overallAvg >= 7
        ? "Very Good"
        : overallAvg >= 6
        ? "Good"
        : overallAvg >= 5
        ? "Pleasant"
        : overallAvg >= 4
        ? "Average"
        : overallAvg >= 3
        ? "Below Average"
        : overallAvg >= 2
        ? "Poor"
        : "Very Poor"}
    </span>
          </div>

          <p className="review-text-property-details">{r.review || "No review text"}</p>
        </div>
      </div>
    ))
  ) : (
    <p>No reviews yet.</p>
  )}
</div>
</div> */}




<div className="review-box">
  <h5>Guest Reviews</h5>

  {reviews.length > 0 ? (
    <div className="reviews-slider-property-details">
      <div className="slider-wrapper-property-details" style={{ transform: `translateX(-${activeReview * 100}%)` }}>
        {reviews.map((r, i) => (
          <div key={i} className="review-card-property-details">
            <div className="review-avatar-property-details">
              <span>{r.user?.fullName?.charAt(0).toUpperCase() || "U"}</span>
            </div>

            <div className="review-content-property-details">
              <h5 className="reviewer-name-property-details">
                {r.user?.fullName || "Unknown User"}
              </h5>

              <div className="review-rating-property-details">
                <span className="rating-score-property-details">
                  {r.ratings?.overall?.toFixed(1) || 0}
                </span>
                <span className="stars-property-details">
                  {"★".repeat(Math.round((r.ratings?.overall || 0) / 2))}
                  {"☆".repeat(5 - Math.round((r.ratings?.overall || 0) / 2))}
                </span>
                <br />
                <span className="status-property-details">
                  {r.ratings?.overall >= 9
                    ? "Exceptional"
                    : r.ratings?.overall >= 8
                    ? "Wonderful"
                    : r.ratings?.overall >= 7
                    ? "Very Good"
                    : r.ratings?.overall >= 6
                    ? "Good"
                    : r.ratings?.overall >= 5
                    ? "Pleasant"
                    : r.ratings?.overall >= 4
                    ? "Average"
                    : r.ratings?.overall >= 3
                    ? "Below Average"
                    : r.ratings?.overall >= 2
                    ? "Poor"
                    : "Very Poor"}
                </span>
              </div>

              <p className="review-text-property-details">
                {r.review || "No review text"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {reviews.length > 1 && (
        <>
          <button className="arrow-property-details prev-property-details" onClick={() => setActiveReview((prev) => (prev === 0 ? reviews.length - 1 : prev - 1))}>❮</button>
          <button className="arrow-property-details next-property-details" onClick={() => setActiveReview((prev) => (prev === reviews.length - 1 ? 0 : prev + 1))}>❯</button>
        </>
      )}

      <div className="slider-dots-property-details">
        {reviews.map((_, i) => (
          <span
            key={i}
            className={`dot-property-details ${i === activeReview ? "active" : ""}`}
            onClick={() => setActiveReview(i)}
          />
        ))}
      </div>
    </div>
  ) : (
    <p>No reviews yet.</p>
  )}
</div>




          <div className="location-box">
            <h6>Location</h6>
            <p>
              <FaMapMarkerAlt /> {property.location?.address}
            </p>
            <div className="location-score">
              {property.location?.score || "0.0"}
            </div>
            <iframe
              src={property.location?.mapEmbed}
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
            <button className="map-btn">Show on map</button>
          </div>
        </div>
      </div>
    </div>




<Facilities property={property} />





<div className="container property-info-container">
      {/* Left column */}
      <div className="property-left">
        <h2>About this property</h2>
        <p>{
          property.propertyDescription
          }
        
        </p>
      

        <h3>Most popular facilities</h3>
        <PropertyAttribute  property={property}   breakfast={breakfast}
  parking={parking}
  />
        {/* <div className="facilities-grid">
          {facilities.map((f, i) => (
            <div key={i} className="facility-item">
              {f.icon}
              <span>{f.label}</span>
            </div>
          ))}
        </div> */}
      </div>

      {/* Right column */}
      <div className="property-right">
        <div className="highlight-card">
          {/* <h3>Property highlights</h3>
          <div className="highlight-section">
            <strong>Breakfast Info</strong>
            <p>Continental, Halal, Buffet</p>
          </div>
          <div className="highlight-section">
            <p>🅿 Free private parking available at the hotel</p>
          </div>
          <div className="highlight-section">
            <strong>Loyal Customers</strong>
            <p>
              There are more repeat guests here than most other properties.
            </p>
          </div> */}

          <h3>Property highlights</h3>

      {/* Breakfast Info */}
      {breakfast.available && (
        <div className="highlight-section">
          <strong>Breakfast Info</strong>
          <p>
            {breakfast.types.join(", ")}{" "}
            {!breakfast.included
              ? `(Available for PKR ${breakfast.price})`
              : "(Included)"}
          </p>
        </div>
      )}

      {/* Parking Info */}
      {parking?.available && (
        <div className="highlight-section">
          <p style={{textTransform:"capitalize"}}>
            🅿{" "}
            {parking.type === "free"
              ? "Free"
              : parking.type === "paid"
              ? `Paid (PKR ${parking.cost})`
              : "Parking available"}{" "}
            {parking.parkingType && `• ${parking.parkingType} parking`}
          </p>
        </div>
      )}

      {/* Loyal Customers */}
      {loyalCustomers && (
        <div className="highlight-section">
          <strong>Loyal Customers</strong>
          <p>
            There are more repeat guests here than most other properties.
          </p>
        </div>
      )}

          <button className="reserve-btn"
  onClick={() => {
    const el = document.getElementById("booking-section-reserve");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }}>Reserve</button>
        </div>
      </div>
    </div>



<div id="booking-section-reserve">

<RoomAvaiablity property={property}/>
</div>

{/* <br /> */}
<div id="reviews-property-detail">

<RoomReviews property={property} />
</div>

{/* <br /> */}
<div id="facilities-property-detail">

<TravelersAsking property={property} />
</div>

{/* <br /> */}
<div id="facilities-property-detail">

<RoomFacilities property={property} />
</div>
<br />
<div id="fine-property-detail">
<div id="rules-property-detail">

<RoomRules property={property} />
</div>
</div>


        </div>
      </div>
    </div>
  );
};

export default SinglePropertyDetail;
